import { useConnection } from '@/features/connections/connection-context';
import { useActiveConnection } from '@/query/gcp';
import { OAuthStatusResponse } from '@firestore-gui/shared';
import { useEffect, useState } from 'react';
import { isOAuthConnected } from './gcp-connection-setup.domain';

interface UseGcpConnectionSetupArgs {
  oauthStatus: OAuthStatusResponse | null;
  onConnectionComplete: () => Promise<void>;
}

export function useGcpConnectionSetup({
  oauthStatus,
  onConnectionComplete,
}: UseGcpConnectionSetupArgs) {
  const [userSelectedProjectId, setUserSelectedProjectId] = useState<string>('');
  const [isConnecting, setIsConnecting] = useState(false);
  const { connectionId } = useConnection();
  const { data: activeConnection, isLoading } = useActiveConnection();

  const selectedProjectId = (userSelectedProjectId || activeConnection?.projectId) ?? '';

  useEffect(() => {
    if (connectionId) {
      queueMicrotask(() => setIsConnecting(false));
    }
  }, [connectionId]);

  const handleProjectSelect = (projectId: string) => {
    setUserSelectedProjectId(projectId);
  };

  const handleDatabaseSelect = async (_databaseId: string) => {
    setIsConnecting(true);
    await onConnectionComplete();
  };

  const handleBackToProjectSelection = () => {
    setUserSelectedProjectId('');
  };

  const shouldShow = isOAuthConnected(oauthStatus);

  return {
    shouldShow,
    loading: isLoading,
    isConnecting,
    selectedProjectId,
    handleProjectSelect,
    handleDatabaseSelect,
    handleBackToProjectSelection,
  };
}
